/**
 * Firebase Authentication Providers
 *
 * Configures authentication providers for Firebase.
 * Currently supports:
 * - Microsoft (Entra ID) via OAuthProvider
 * - Email/Password (built-in)
 *
 * The Microsoft provider is configured to use the organisation's
 * Entra ID tenant for SSO.
 */

import { OAuthProvider } from 'firebase/auth';

/**
 * Microsoft OAuth Provider
 *
 * Configured to use the organisation's Entra ID tenant.
 * Falls back to 'common' tenant for multi-tenant scenarios.
 */
export const microsoftProvider = new OAuthProvider('microsoft.com');

// Configure Microsoft provider with tenant-specific settings
microsoftProvider.setCustomParameters({
  // Use the specific tenant or 'common' for any Microsoft account
  tenant: import.meta.env.VITE_ENTRA_TENANT_ID || 'common',
  // Always show account selection
  prompt: 'select_account',
});

// Add scopes for user profile access
microsoftProvider.addScope('openid');
microsoftProvider.addScope('profile');
microsoftProvider.addScope('email');

/**
 * Provider type identifiers
 */
export type AuthProviderType = 'microsoft' | 'email';

/**
 * Check if a provider type is valid
 */
export function isValidProvider(provider: string): provider is AuthProviderType {
  return provider === 'microsoft' || provider === 'email';
}
